module Meevo.Plugins.DocsAndForms {
    'use strict';
    import IService = Meevo.Plugins.WalkinManager.AddToWaitlist.IService;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import ISelectItem = Meevo.Model.ISelectItem;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;
    import ICheckBoxListItem = Meevo.Components.Controls.ICheckBoxListItem;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    const LENGTH_TYPES: ISelectItem<DocsAndFormsLifeSpanEnum>[] = [
        { label: 'LABEL_MONTH(S)', value: DocsAndFormsLifeSpanEnum.Months },
        { label: 'LABEL_DAY(S)', value: DocsAndFormsLifeSpanEnum.Days }
    ];

    interface IServiceCriteria {
        serviceCategoryId?: string;
        objectStateEnumList?: Array<ObjectStateEnum>;
        genderEnumList?: Array<Number>;
        displayName?: null;
        fieldOrderBy?: string;
        orderAscDesc?: string;
    }

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<any> {
        public serviceCriteria: IServiceCriteria;
        public serviceCategoryModel: IService;
        public objectState: Number = 2026;
        public activeStateWasChanged: boolean;
        public messageSentItems: ICheckBoxListItem[];

        public Appointment: Array<any> = [
            { value: FormAndDocsAppointment.Booked, label: 'LABEL_BOOKED' },
            // { value: FormAndDocsAppointment.CheckedIn, label: 'LABEL_CHECKED_IN' },
            // { value: FormAndDocsAppointment.CheckedOut, label: 'LABEL_CHECKED_OUT' }
        ];
          
        public View: Array<any> = []; // start as empty but then fill with DocsAndFormsModel.FillFormTypes items based on security;

        private _model: DocsAndFormsModel;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;

        get lengthTypes() {
            return LENGTH_TYPES;
        }

        get formAndDocsView() {
            return FormAndDocsView;
        }

        get model() {
            return this._model;
        }

        set model(model: IDocsAndFormsModel) {
            if (!model) {
                this._model = null;
                return;
            }

            if (!(model instanceof DocsAndFormsModel)) {
                this._model = new DocsAndFormsModel(model);
            } else {
                this._model = model;          
            }
            this.checkModuleAccessAndFilterView();
        }

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected dafAPIService: DocsAndFormsApiService,
            protected securityChecker: Meevo.Components.Common.ISecurityService,
            protected $q: ng.IQService) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.activeStateWasChanged = false;
            this.serviceCriteria = {
                serviceCategoryId: null,
                objectStateEnumList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                genderEnumList: [92, 93, 94, 2035],
                displayName: null,
                fieldOrderBy: 'DisplayName',
                orderAscDesc: 'Ascending'
            };

            this.messageSentItems = [
                {
                    key: 'sendUponBooking',
                    labelText: 'LABEL_UPON_BOOKING_APPOINTMENT'
                },
                {
                    key: 'sendUponConfirming',
                    labelText: 'LABEL_UPON_CONFIRMING_APPOINTMENT'
                },
            ];
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */

        checkModuleAccessAndFilterView() {
            if (!this._model || this.View.length > 0) return;

            const isNewForm = !this._model.id;
            const thisModel = this.model as DocsAndFormsModel;

            var promises = [
                this.securityChecker.checkModuleAccess(this.securityKeys.APPOINTMENTS_APPOINTMENTBOOK + Meevo.Components.Common.SecurityParts.KEY_PART_READ),
                this.securityChecker.checkModuleAccess(this.securityKeys.MEMBERSHIP_MEMBERSHIP + Meevo.Components.Common.SecurityParts.KEY_PART_READ),
                this.dataService.customMethodData("api/Module/TenantList", "POST", { moduleId: Meevo.Model.ModuleEnum.PaymentPlans, tenantId: this.identityService.current().tenantId }),
                this.dataService.customMethodData("api/Tenant/BusinessInfo/Preferences/Setting", "POST", { locationId: this.identityService.current().locationId, tenantId: this.identityService.current().tenantId, settingRequestType: Model.BusinessSettingCategoryEnum.PaymentPlans, businessTypeId: this.identityService.current().businessTypeId })
            ];

            this.$q.all(promises)
                .then((responses: any[]) => {
                    if (responses && responses.length > 0) {
                        // Appointment Module Access
                        if (responses[0] === Model.SecurityAccessEnum.Grant || (!isNewForm && (thisModel.formFillTypeEnum === FormFillTypeEnum.OnlyOnce || thisModel.formFillTypeEnum === FormFillTypeEnum.EveryTime))) {
                            this.View.push(...DocsAndFormsModel.FillFormTypes.filter(item => item.value === FormFillTypeEnum.OnlyOnce || item.value === FormFillTypeEnum.EveryTime));
                        }

                        // Membership Module Access
                        if ((responses.length > 1 && responses[1] === Model.SecurityAccessEnum.Grant) || (!isNewForm && thisModel.formFillTypeEnum === FormFillTypeEnum.Membership)) {
                            this.View.push(...DocsAndFormsModel.FillFormTypes.filter(item => item.value === FormFillTypeEnum.Membership));
                        }

                        // Payment Plan Module Access
                        if (((responses.length > 2 && responses[2].data.length > 0 && responses[2].data[0].securityAccess === Model.SecurityAccessEnum.Grant)
                            && (!this.identityService.current().isSingleLocation || (this.identityService.current().isSingleLocation && responses.length > 3 && responses[3].data && responses[3].data.paymentPlansSettings &&
                                responses[3].data.paymentPlansSettings.enablePaymentPlans === true))
                            || (!isNewForm && thisModel.formFillTypeEnum === FormFillTypeEnum.PaymentPlan))) {
                            this.View.push(...DocsAndFormsModel.FillFormTypes.filter(item => item.value === FormFillTypeEnum.PaymentPlan));
                        }
                    }
                });
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.model = new DocsAndFormsModel(<IDocsAndFormsModel>{
                objectState: Model.ObjectStateEnum.Inactive,
                tabTypeEnum: FormTypeEnum.Form,
                deliveryMethodEnum: FormAndDocsDelivery.DoNotSend,
                formTypeLocked: false,
            });
            this.postCancel();
            this.takeBackup();
        }

        preSave() {
            this.serviceCriteria.serviceCategoryId = null;
            this.serviceCategoryModel = null;
        }

        rollbackChanges() {
            super.rollbackChanges();
            this.serviceCriteria.serviceCategoryId = null;
            this.serviceCategoryModel = null;
        }

        onSearchParamsChanged() {
            this.serviceCriteria.serviceCategoryId = this.serviceCategoryModel ? this.serviceCategoryModel.id : null;
        }

        onLifeSpanChanged() {
            // NOTE: this.model.lifeSpan as any === '' for case when meevo-spinner returns '' instead null
            if (angular.isUndefined(this.model.lifeSpan) || this.model.lifeSpan === null || this.model.lifeSpan as any === '') {
                this.model.formLifeSpanTypeEnum = null;
            }

            if (!this.model.formLifeSpanTypeEnum && this.model.lifeSpan) {
                this.model.formLifeSpanTypeEnum = this.lengthTypes[0].value;
            }
        }

        onLifeSpanTypeChanged() {
            if (!this.model.lifeSpan && this.model.formLifeSpanTypeEnum) {
                this.model.lifeSpan = 1;
            }
        }

        formFillTypeChanged() {
            this.model.deliveryMethodEnum = FormAndDocsDelivery.DoNotSend;
            this.model.deliveryMethodText = false;
            this.model.deliveryMethodEmail = false;
            if (this.model.formFillTypeEnum == FormFillTypeEnum.Membership || this.model.formFillTypeEnum == FormFillTypeEnum.PaymentPlan) {
                this.model.sendUponBooking = false;
                this.model.sendUponConfirming = false;
                this.model.sendXDaysBeforeAppointment = false;
                this.model.daysBeforeAppointment = null;
                this.model.sendUponFinalizeTransaction = true;
            }
            else if (this.model.formFillTypeEnum == FormFillTypeEnum.OnlyOnce || this.model.formFillTypeEnum == FormFillTypeEnum.EveryTime) {
                this.model.sendUponFinalizeTransaction = false;
                this.model.daysBeforeAppointment = 1;
            }
        }

        objectStateChanged() {
            let thisModel = this.model as DocsAndFormsModel;

            if (thisModel.objectState === Model.ObjectStateEnum.Active) {
                thisModel.suppressWarnings = false;
            }
        }
    }


}
